export default __webpack_public_path__ + "static/media/pngweb.a46c1221.png";